(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $location, $rootScope, sessionData, locales, brand) {
    var session = sessionData.getAll();

    if (session[sessionData.Keys.LANGUAGE_KEY]) {
      locales.setLanguage(session[sessionData.Keys.LANGUAGE_KEY]);
    }

    // Dynamic favicon
    /* eslint-disable */
    (function changeFavicon() {
      var link;
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = (brand === 'r2w') ? 'favicon.ico' : 'favicon_karcher.ico';
        document.getElementsByTagName('head')[0].appendChild(link);
    })();
    /* eslint-enable */

    // $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {

    //     if (toState.name === 'app.userGroups.new') {
    //         // check if flag is set (if user is started creating new group)
    //         if(toState.data.changingFlag){
    //           e.preventDefault();
    //           return;
    //           // popup dialog
    //         }

    //         $state.go(toState.name);
    //     }
    // });

    $log.debug('runBlock end');
  }

})();
